import React, {useEffect, useState} from 'react'
import {PageContainer, SearchBoxContainer} from '../../../assets/styles/layout'
import Routes from '../../../constants/RouteConstants'
import PageHeader from '../../PageHeader'
import ClearableInput from '../../ClearableInput'
import {makeStyles} from '@mui/styles'
import ListChatSettingsTable from './ListChatSettingsTable'
import {generatePath, useHistory, matchPath, useLocation} from 'react-router-dom'
import SidePanel from '../../SidePanel'
import {Grid} from '@mui/material'
import {spaceMedium} from '../../../assets/styles/spacing'
import LoadingStateIconAndMessage from '../../LoadingStateIconAndMessage'
import EditBuildingChatSettings from './EditBuildingChatSettings'
import {useSelector} from 'react-redux'

function ChatSettings(props) {
  const classes = useStyles()
  const [filterTerm, setFilterTerm] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const history = useHistory()
  const {pathname} = useLocation()

  const viewBuildingMatch = matchPath(pathname, {path: Routes.ADMIN_DASHBOARD_CHAT_SETTINGS_VIEW_BUILDING})
  const focusedBuildingId = viewBuildingMatch ? viewBuildingMatch.params.buildingId : null
  const focusedBuilding = useSelector(state => state.GlobalAdmin.buildingsLookup[focusedBuildingId])

  const closeSidePanel = () => {
    history.push(Routes.ADMIN_DASHBOARD_CHAT_SETTINGS)
  }

  return (
    <div style={PageContainer}>
      <PageHeader title={'RXO Chat Settings'} hideTrademark={true}>
        <Grid container spacing={3} style={{marginBottom: spaceMedium}}>
          <Grid item md={6}>
            <div className={classes.searchAssetsContainer}>
              <ClearableInput value={filterTerm} onChange={setFilterTerm} placeholder={'Search'} />
            </div>
          </Grid>
        </Grid>
      </PageHeader>

      <div style={{flex: 1}}>
        {isLoading ? (
          <LoadingStateIconAndMessage message={'Loading chat settings...'} />
        ) : (
          <ListChatSettingsTable
            filterTerm={filterTerm}
            onClickBuilding={bId => {
              history.push(generatePath(Routes.ADMIN_DASHBOARD_CHAT_SETTINGS_VIEW_BUILDING, {buildingId: bId}))
            }}
          />
        )}
      </div>

      <SidePanel isOpen={!!focusedBuildingId} onClose={closeSidePanel} title={`${focusedBuilding?.displayName} chat settings`}>
        <EditBuildingChatSettings buildingId={focusedBuildingId} onCancel={closeSidePanel} />
      </SidePanel>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  searchAssetsContainer: {
    ...SearchBoxContainer,
  },
}))

export default ChatSettings
